import React__default from 'react';
import _s, { css } from 'styled-components';

const variantMapping = {
  'headline-1': 'h1',
  'headline-2': 'h2',
  'headline-3': 'h3',
  'body-1': 'p',
  'body-2': 'p',
  'label-1': 'span',
  'label-2': 'span',
  'label-3': 'span',
  'caption-1': 'div',
  'caption-2': 'div',
  jumbo: 'h2',
  'section-title': 'h2'
};

const styled = typeof _s === "object" && "default" in _s ? _s.default : _s;
const Typography = ({
  center,
  children,
  color,
  display,
  ellipsis,
  lineThrough,
  htmlTitle,
  testID,
  variant,
  fontWeight
}) => {
  return /*#__PURE__*/React__default.createElement(Text, {
    "$center": center,
    "$color": color,
    "$display": display,
    "$ellipsis": ellipsis,
    "$lineThrough": lineThrough,
    "$variant": variant,
    as: variantMapping[variant],
    "data-testid": testID,
    title: htmlTitle || undefined,
    "$fontWeight": fontWeight
  }, children);
};
const Text = styled.div`
  padding: 0;
  margin: 0;

  ${({
  theme,
  $color,
  $variant,
  $fontWeight
}) => {
  const font = theme.typographies[$variant];
  return css(["color:", ";font-family:", ";font-size:", "px;font-weight:", ";line-height:", "px;"], theme.colors[$color], font === null || font === void 0 ? void 0 : font.fontFamily, font === null || font === void 0 ? void 0 : font.fontSize, $fontWeight !== null && $fontWeight !== void 0 ? $fontWeight : font === null || font === void 0 ? void 0 : font.fontWeight, font === null || font === void 0 ? void 0 : font.lineHeight);
}}

  ${({
  theme,
  $color,
  $lineThrough
}) => $lineThrough && css(["text-decoration-color:", ";text-decoration:line-through;"], theme.colors[$color])}

  ${({
  $center
}) => $center && css(["text-align:center;"])}

  ${({
  $display
}) => $display && css(["display:", ";"], $display)}

  ${({
  $ellipsis
}) => $ellipsis && css(["display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"])}
`;

export { Typography as default };
//# sourceMappingURL=Typography.js.map
